module.exports = __webpack_public_path__ + "static/media/02.9e91af96.png";